import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type WithSignal, type AccountRequest, type AccountResponse } from '@shared/api';

const getAccountsEffect = createEffect(({ signal, ...request }: WithSignal<AccountRequest> = {}) => AccountsApi.getAccounts(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<AccountResponse[]>([])
  .on(getAccountsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAccountsEffect.pending, (_, data) => data)
  .on(getAccountsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountsEffect, () => null)
  // .on(getAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountsEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Accounts. Please try again.'),
  )
  .on(getAccountsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getAccountsApi = ApiUtils.wrapperApi(getAccountsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getAccountsApi.cancel());

export const $accountPaymentListStore = {
  events: {
    getAccounts: getAccountsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
